export default __webpack_public_path__ + "static/media/expressjs-icon.da040fa9.svg";